/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type TradeOnboardingCoachmarkConditionalLoader_user$ref: FragmentReference;
export type TradeOnboardingCoachmarkConditionalLoader_user = {|
  +serviceId: ?string,
  +$refType: TradeOnboardingCoachmarkConditionalLoader_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "TradeOnboardingCoachmarkConditionalLoader_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'f94bcabbf168345679c1f91512d4e4ae';
module.exports = node;
